const parseAmount = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined || value === '') continue;

    const amount = Number(value);
    if (Number.isFinite(amount)) {
      return amount;
    }
  }

  return null;
};

const isEnabled = (value) => value === true || value === 'true' || value === 1 || value === '1';

export const getGiftConfigurationPricing = (configuration = {}) => {
  const discountAmount = parseAmount(
    configuration.discount_amount,
    configuration.event_discount_amount,
    configuration.event_discount,
    configuration.discount
  );

  const normalPrice = parseAmount(
    configuration.normal_price,
    configuration.product_price,
    configuration.public_price,
    configuration.original_price
  );

  const redemptionValue = parseAmount(
    configuration.redemption_value,
    configuration.redeem_value,
    configuration.face_value,
    configuration.value,
    configuration.original_price,
    normalPrice
  );

  const configuredPrice = parseAmount(configuration.price);
  const isVoucherFixe = configuration.type === 'voucher_fixe';
  const hasProduct = Boolean(configuration.product_id);
  const isLegacyEventShape =
    isVoucherFixe &&
    hasProduct &&
    configuredPrice !== null &&
    redemptionValue !== null &&
    normalPrice !== null &&
    redemptionValue === normalPrice &&
    configuredPrice > 0 &&
    configuredPrice < redemptionValue / 2;
  const isEventOffer = isEnabled(configuration.event_offer) || isLegacyEventShape;
  const legacyEventDiscountAmount =
    isEventOffer &&
    discountAmount === null &&
    configuredPrice !== null &&
    redemptionValue !== null &&
    configuredPrice > 0 &&
    configuredPrice < redemptionValue / 2
      ? configuredPrice
      : null;

  const eventDiscountedPurchasePrice =
    isEventOffer &&
    redemptionValue !== null &&
    (discountAmount !== null || legacyEventDiscountAmount !== null)
      ? Math.max(0, redemptionValue - (discountAmount ?? legacyEventDiscountAmount))
      : null;

  const purchasePrice = parseAmount(
    configuration.purchase_price,
    configuration.sale_price,
    eventDiscountedPurchasePrice,
    configuredPrice,
    normalPrice !== null && discountAmount !== null ? Math.max(0, normalPrice - discountAmount) : null
  );

  const promotionAmount = parseAmount(
    redemptionValue,
    purchasePrice
  );

  const computedDiscountAmount =
    redemptionValue !== null &&
    purchasePrice !== null &&
    redemptionValue > purchasePrice
      ? redemptionValue - purchasePrice
      : discountAmount ?? legacyEventDiscountAmount;

  return {
    purchasePrice: purchasePrice ?? 0,
    redemptionValue: redemptionValue ?? purchasePrice ?? 0,
    promotionAmount: promotionAmount ?? 0,
    discountAmount: computedDiscountAmount ?? 0,
    hasDiscountedPurchase:
      redemptionValue !== null &&
      purchasePrice !== null &&
      redemptionValue > purchasePrice,
  };
};
